import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const CompanyService = {
  getAllCompanyList(obj) {
    return httpClient.post(endPoints.getAllCompanyList, obj);
  },
  getCompanyDetail(obj) {
    return httpClient.post(endPoints.getCompanyDetail, obj);
  },
  addCompany(obj) {
    return httpClient.post(endPoints.addCompany, obj);
  },
  updateCompany(obj) {
    return httpClient.post(endPoints.updateCompany, obj);
  },
  deleteCompany(obj) {
    return httpClient.post(endPoints.deleteCompany, obj);
  },
};

export default CompanyService;



// WEBPACK FOOTER //
// ./src/service/CompanyService.js